import { Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import {GLanguageProvider} from '../General/g-language.provider'

/** Class used to load the Language from a json-file
* The file need to be located in src/assets
* The default is the german file
*/
@Injectable()
export class LanguageProvider extends GLanguageProvider{	
    constructor(protected http: HttpClient) {
		super(http);
		this.languageFileNameEnding = "dataRepresentation";
		this.setFileName();
	}

}